import { useEffect } from "react";
import { useRouter } from "next/router";
import { generateNextSeo } from "next-seo/pages";
import Head from "next/head";
import { DefaultLayout } from "src/layouts/DefaultLayout";
import UpgradePageContent from "src/components/subscriptions/UpgradePageContent";
import { useFeatureFlags } from "src/contexts/FeatureFlagProvider";

export default function UpgradePage() {
  const router = useRouter();
  const { featureFlags } = useFeatureFlags();

  useEffect(() => {
    if (!featureFlags.sharedAlbumsUpgrade) {
      router.push("/upgrade");
    }
  }, [router, featureFlags.sharedAlbumsUpgrade]);

  if (!featureFlags.sharedAlbumsUpgrade) {
    return null;
  }
  return (
    <>
      <Head>{generateNextSeo({ noindex: true })}</Head>
      <DefaultLayout continueUrl="/albums/upgrade">
        <UpgradePageContent entryPoint="shared-albums" />
      </DefaultLayout>
    </>
  );
}

UpgradePage.enableSessionRecording = true;
